export default "__VITE_ASSET__AfmNU0Kf__"